import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const http = axios.create({ withCredentials: true });

export const api = {
  create: (title: string, code: string) => http.post(`${API}/presentations`, { title, code }).then((r) => r.data),
  get: (slug: string) => http.get(`${API}/presentations/${slug}`, { timeout: 8000 }).then((r) => r.data),
  verify: (slug: string, code: string) => http.post(`${API}/presentations/${slug}/verify`, { code }).then((r) => r.data),
  logout: (slug: string) => http.post(`${API}/presentations/${slug}/logout`).then((r) => r.data),
  put: (slug: string, key: string, value: any, author: string) =>
    http.put(`${API}/presentations/${slug}/data/${key}`, { value, author }, { timeout: 10000 }).then((r) => r.data),
  changeCode: (slug: string, old: string, nw: string) => http.put(`${API}/presentations/${slug}/code`, { old, new: nw }).then((r) => r.data),
  history: (slug: string, key: string) => http.get(`${API}/presentations/${slug}/history/${key}`).then((r) => r.data.items as { v: any; by: string; at: string }[]),
  upload: (slug: string, file: File) => {
    const f = new FormData();
    f.append('file', file);
    return http.post(`${API}/presentations/${slug}/images`, f).then((r) => r.data);
  },
  fileUrl: (p: string) => `${API}/files/${p}`,
};

export const errMsg = (e: any) => e?.response?.data?.detail || 'Erreur réseau';
